// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1J6xj","obliqueLineWrap":"membershipbadge_obliqueLineWrap__37b3s","obliqueLine":"membershipbadge_obliqueLine__2tTvF"};